import * as de from '../../translations/de';

export function moduleInitializerFactory(translationService, settings): () => void {
  return () => {
    translationService.addTranslations('de', de.translations);
    translationService.useLanguage(settings.translationLanguage, 'de');
  };
}
